export default __webpack_public_path__ + "static/investor-relations-00ecaa35206dbce4aeb827c7783fed76.png";